// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__w-r9p","placeholdersHeader":"styles_placeholdersHeader__1T_C1","editorStyle":"styles_editorStyle__2ZTPm","placeholdersBox":"styles_placeholdersBox__2GLnL"};